import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Btn } from "@/components/erp/ui";
import { err } from "@/components/erp/flow/FlowCommon";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

const Chart = ({ title, rows, tid }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={tid}>
    <div className="font-semibold text-sm mb-2">{title}</div>
    {rows.length ? (
      <div className="h-56"><ResponsiveContainer><BarChart data={rows.map((r) => ({ ...r, label: String(r.name).slice(0, 16) }))}>
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" /><XAxis dataKey="label" fontSize={10} /><YAxis fontSize={11} allowDecimals={false} /><Tooltip /><Legend />
        <Bar dataKey="pass" name="Lolos" stackId="a" fill="#059669" /><Bar dataKey="fail" name="Tidak lolos" stackId="a" fill="#e11d48" />
      </BarChart></ResponsiveContainer></div>
    ) : <p className="text-xs text-slate-400">Belum ada data QC.</p>}
    {rows.map((r) => <div key={r.name} className="text-xs flex justify-between border-b border-slate-50 py-0.5"><span>{r.name}</span><span className={r.rate < 80 ? "text-rose-600 font-semibold" : "text-emerald-700"}>{r.rate}% lolos · {r.pass}/{r.total}</span></div>)}
  </div>
);

export const QcRecap = () => {
  const [days, setDays] = useState(90); const [d, setD] = useState(null);
  useEffect(() => { api.get(`/flow/qc-recap?days=${days}`).then(({ data }) => setD(data)).catch(err); }, [days]);
  return (
    <details className="rounded-2xl border border-slate-200 bg-slate-50 p-4 mb-5" data-testid="qc-recap">
      <summary className="font-semibold cursor-pointer">Rekap kualitas QC (tingkat lolos per tingkat, petugas & produk)</summary>
      <div className="flex gap-2 my-3">{[30, 90, 365].map((n) => <Btn key={n} variant={n === days ? "primary" : "ghost"} data-testid={`qc-recap-days-${n}`} onClick={() => setDays(n)}>{n} hari</Btn>)}</div>
      {d && <div className="grid lg:grid-cols-2 gap-3">
        <Chart title="Per tingkat QC" rows={d.levels} tid="qc-recap-levels" />
        <Chart title="Per petugas QC" rows={d.operators} tid="qc-recap-ops" />
        <Chart title="Per produk (terendah dulu)" rows={d.products} tid="qc-recap-products" />
        <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="qc-recap-items">
          <div className="font-semibold text-sm mb-2">Poin cek paling sering gagal</div>
          {d.fail_items.map((x) => <div key={x.key} className="text-xs flex justify-between border-b border-slate-50 py-1"><span>{x.name}</span><b className="text-rose-600">{x.count}x</b></div>)}
          {!d.fail_items.length && <p className="text-xs text-slate-400">Belum ada QC gagal.</p>}
        </div>
      </div>}
    </details>
  );
};
